<template>
    <page title="checkingTitle" :info="info"  :help="help">
        <template #pageContainer>
            <v-row>
                <v-col
                    cols="12"
                    md="12">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="Entities"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="50"
                            :loading="loading"
                            :loading-text="$t('text.checkingLoading')"
                            :server-items-length="Entities.length"
                            hide-default-footer
							:height="WindowSize.y - 305"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-btn-toggle dense
                                                color="primary"
                                                active-class="action-active">
                                                <v-btn
                                                    color="primary"
                                                    @click="back">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.backButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        arrow_back
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="decline(item.id, item.status)">
                                            <v-icon v-if="item.status === checkingStatus.NotDecided">
                                                event_note
                                            </v-icon>
                                            <v-icon v-else>
                                                event_busy
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span v-if="item.status === checkingStatus.NotDecided">{{ $t(`text.notDecidedChecking`) }}</span>
                                    <span v-else>{{ $t(`text.negativeChecking`) }}</span>
                                </v-tooltip>
                            </template>
                            <template #[`item.statusLocalized`]="{ item }">
                                <v-chip :color="getStatusColor(item.status)" dark>
                                    {{ item.statusLocalized }}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Page from '../general/Page.vue';

import checkingStatus from '../helpers/checkingStatus';

import performanceActions from '../store/actions/performance';
import checkingActions from '../store/actions/checking';
import namespace from '../store/namespace';

export default {
	name: 'Checking',
	components: {
		Page,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'center', value: 'action', sortable: false, width: 150,
				},
				{
					text: this.$i18n.t('text.headerBestlistName'), align: 'left', value: 'name', sortable: false, width: 200,
				},
				{
					text: this.$i18n.t('text.headerRegionalRestriction'), align: 'left', value: 'regionalRestrictionName', sortable: false, width: 200,
				},
				{
					text: this.$i18n.t('text.headerStatus'), align: 'left', value: 'statusLocalized', sortable: false,
				},
			],
			perfId: this.$route.params.id,
			loading: true,
			queryParameters: {
				pageNumber: 1,
				pageSize: 10,
			},
			perf: null,
			info: '',
			help: [{
				icon: 'event_busy',
				text: this.$t('text.negativeChecking'),
			},
			{
				icon: 'event_note',
				text: this.$t('text.notDecidedChecking'),
			}],
		};
	},
	async mounted() {
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['ExternalId']),
		...mapGetters(namespace.USER, ['User']),
		...mapGetters(namespace.PERFORMANCE, { ParrentEntities: 'Entities' }),
		...mapGetters(namespace.CHECKING, ['Links', 'Entities', 'Pagination']),
		checkingStatus() {
			return checkingStatus;
		},
	},
	methods: {
		...mapActions(namespace.CHECKING, [
			checkingActions.GET_CHECKING,
			checkingActions.UPDATE_CHECKING]),
		...mapActions(namespace.PERFORMANCE, [
			performanceActions.GET_PERFORMANCE_BY_ID]),
		async loadData() {
			this.loading = true;
			try {
				if (this.ParrentEntities.length == 0) {
					this.perf = await this.GET_PERFORMANCE_BY_ID(this.perfId);
				} else {
					this.perf = this.ParrentEntities.find(perf => perf.id === this.perfId);
				}
				this.info = `${this.perf.eventShortNational} ${this.perf.classShort} ${this.perf.bestResult} ${this.perf.competitorFullName}`;

				const checkingRequest = {
					masterOrgId: this.ExternalId,
					perfId: this.perfId,
				};

				await this.GET_CHECKING(checkingRequest);
			} finally {
				this.loading = false;
			}
		},
		async decline(id, status) {
			const item = {
				status,
				reason: '',
				perfId: this.perfId,
				perfListId: id,
				userId: this.User.id,
			};

			await this.update(item);
		},
		back() {
			this.$router.go(-1);
		},
		getStatusColor(status) {
			switch (status) {
			case checkingStatus.NotDecided: return 'gray';
			case checkingStatus.Positive: return 'green';
			case checkingStatus.Negative: return 'red';
			case checkingStatus.OtherReservedValue: return 'blue';
			default: return 'white';
			}
		},
		async update(item) {
			this.loading = true;
			try {
				await this.UPDATE_CHECKING(item);

				await this.loadData(this.queryParameters);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
